import { jsx, Fragment } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { pseudoDot } from "./DotSeparator.css.mjs";
const DotSeparator = ({ content }) => /* @__PURE__ */ jsx(Fragment, { children: content.map((item, index) => /* @__PURE__ */ jsx(Box, { display: "inline", className: pseudoDot, children: item }, index)) });
export {
  DotSeparator
};
